<template>
  <section class="relative">
    <div class="hidden md:block">
      <appbar-component></appbar-component>
    </div>
    <div
      v-if="!navDrawer"
      class="py-5 bg-black fixed top-0 z-40 w-full pl-5 md:hidden cursor-pointer"
    >
      <button @click="openNav">
        <img src="/icons/menu.svg" alt="menu" />
      </button>
    </div>

    <div v-if="navDrawer" class="md:hidden">
      <navigation-drawer @close-button="closeMol()"></navigation-drawer>
    </div>

    <main class="min-h-screen h-full">
      <router-view />
    </main>

    <footer>
      <footer-component></footer-component>
    </footer>
    <div class="fixed bottom-10 right-5 z-50">
      <button>
        <a
          data-action="open"
          data-phone="9049439540"
          data-message="Welcome to Lubx Engine Oil, How can we help?"
          role="button"
          title="chat with us on whatsapp"
          tabindex="0"
          target="_blank"
          href="https://web.whatsapp.com/send?phone=9049439540&amp;text=Welcome%20to%20Lubx%20Engine%20Oil%2C%20How%20can%20we%20help%3F"
        >
          <img
            src="/icons/whatsapp.svg"
            class="w-[80px] h-[80px]"
            alt="whatsapp"
          />
        </a>
      </button>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import AppbarComponent from "./components/AppbarComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";
import NavigationDrawer from "./components/NavigationDrawer.vue";

const navDrawer = ref(0);

function openNav() {
  navDrawer.value = true;
}
function closeMol() {
  navDrawer.value = false;
}
</script>

<style lang="scss" scoped></style>
